/**
 * @fileoverview GET handler for the "/data_objects/:type_name" list endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeName } from "./constants";
import type { CustomObjectsTypeNameParams, CustomObjectsTypeNameResult } from "./types";
import { isCustomObjectsTypeNameResult } from "./validators";

export const getDataTableCustomObjectsTypeName = reactQueryTableFetcherAdapter(
  customObjectsTypeName,
  (
    signal: AbortSignal,
    { appGroupId, typeName, search_term, limit = 12, start = 0 }: CustomObjectsTypeNameParams
  ): Promise<CustomObjectsTypeNameResult> => {
    return fetch(
      `/data_objects/${typeName}`,
      "GET",
      {
        app_group_id: appGroupId,
        limit,
        start,
        search_term,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isCustomObjectsTypeNameResult
);
